<template>
  <ModalDialog
    ref="dialog"
    title="Edit Price Request Sales Price"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-money-check-edit-alt"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <LoadingPanel ref="loadingPanel" @update="loading = $event" />
      <div v-if="!loading">
        <FormRow label="Stock">
          <FormStaticLabel><strong>{{stockDescription}}</strong></FormStaticLabel>
        </FormRow>
        <FormRow label="Is Active">
          <FormCheckbox v-model="stockSalesPriceData.isActive" field="isActive" />
        </FormRow>
        <FormRow label="Price">
          <FormInputCurrency v-model="stockSalesPriceData.price" field="price" />
        </FormRow>
        <FormRow label="Min Charge Price Per Item">
          <FormInputCurrency
            v-model="stockSalesPriceData.minChargeItemPrice"
            field="minChargeItemPrice"
            note="Leave blank to use system / price group default"
          />
        </FormRow>
        <FormRow label="Min Charge Price Per Group">
          <FormInputCurrency
            v-model="stockSalesPriceData.minChargePrice"
            field="minChargePrice"
            note="Leave blank to use system / price group default"
          />
        </FormRow>
        <FormRow label="Min Charge Quantity" v-if="isGlassStock">
          <FormInputText
            type="number"
            v-model="stockSalesPriceData.minChargeQuantity"
            field="minChargeQuantity"
            note="Leave blank to use price group default"
          />
        </FormRow>
        <FormRow label="Min Invoice Price" v-if="isGlassStock || isGlassServiceStock">
          <FormInputCurrency
            v-model="stockSalesPriceData.minChargeInvoice"
            field="minChargeInvoice"
            note="Leave blank to use price group default"
          />
        </FormRow>
      </div>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'PriceRequestEditSalesPriceDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    priceRequestId: Number,
    stockSalesPriceId: Number
  },
  data() {
    return {
      dialogForm: {},
      submitting: false,
      loading: false,
      stockSalesPriceData: {}
    }
  },
  created() {
  },
  mounted() {
    
  },
  computed: {
    stockDescription() {
      if(!this.stockSalesPriceData.stock)
        return ''
      if(this.isGlassStock && this.stockSalesPriceData.stockPriceGroup)
        return `${this.stockSalesPriceData.stock.code} - ${this.stockSalesPriceData.stock.name} - ${this.stockSalesPriceData.stockPriceGroup.name}`
      if(this.isGlassServiceStock && this.stockSalesPriceData.stockPriceGroup && this.stockSalesPriceData.servicePriceRange)
        return `${this.stockSalesPriceData.stock.code} - ${this.stockSalesPriceData.stock.name} - ${this.stockSalesPriceData.stockPriceGroup.name} - ${this.stockSalesPriceData.servicePriceRange.name}`

      return `${this.stockSalesPriceData.stock.code} - ${this.stockSalesPriceData.stock.name}`
    },
    isGlassStock() {
      if(!this.stockSalesPriceData.stock)
        return false
      return this.stockSalesPriceData.stock.type == InventoryStockTypes.glass
    },
    isGlassServiceStock() {
      if(!this.stockSalesPriceData.stock)
        return false
      return this.stockSalesPriceData.stock.type == InventoryStockTypes.glassService
    }    
  },
  methods: {
    show() {
      // Reset form
      this.dialogForm = { }
      this.requestData()

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      this.$apiService.pricingService.updatePriceRequestStockSalesPrice(this.priceRequestId, this.stockSalesPriceId, this.stockSalesPriceData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    requestData() {
      this.$refs.loadingPanel.startLoading()
      this.$apiService.pricingService.getPriceRequestStockSalesPrice(this.priceRequestId, this.stockSalesPriceId)
      .then(response => {
        this.stockSalesPriceData = response.data
      })
      .catch(err => {
        this.$refs.loadingPanel.setError('Error accessing stock pricing data', err)
      })
      .finally(() => {
        this.$refs.loadingPanel.finishedLoading()
      })
    }
  }
}
</script>